import { Button } from 'antd'
import { useParams } from 'react-router-dom'
import { exportThesisMarkdown } from '@/lib/exportThesisMarkdown'

const NovelExport = () => {
  const { novelId } = useParams()
  return (
    <div className="space-y-3 p-4">
      <p className="thesis-muted text-sm">导出当前论文为 Markdown，可再导入 Word。</p>
      <Button type="primary" onClick={() => exportThesisMarkdown(novelId)}>
        导出 Markdown
      </Button>
    </div>
  )
}

export default NovelExport
